import { AddCircle, Copy } from "react-solar-set/essentionalui";
import { Banner } from "../../components/ui/Banner";
import Button from "../../components/ui/Button";
import { motion } from "framer-motion"; // Add this import
import { projects } from "../../data/content";

export const RecentProjectsSection = () => {
    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
            },
        },
    };

    const item = {
        hidden: { opacity: 0, y: 20 },
        show: { opacity: 1, y: 0 },
    };

    return (
        <div className="flex flex-col space-y-4">
            {/* Banner */}
            <Banner title="Recent Projects" />
            {/*  */}
            <motion.div
                className="flex flex-wrap px-4 sm:px-10 mt-3"
                variants={container}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
            >
                {/*  */}
                {projects.map((project, index) => (
                    <motion.div
                        key={index}
                        className="w-full sm:w-1/2 p-4"
                        variants={item}
                        whileHover="hover"
                        initial="rest"
                        animate="rest"
                    >
                        <motion.div
                            className="w-full h-full border border-button rounded p-5 flex flex-col gap-4 items-start group"
                            variants={{
                                rest: { boxShadow: "0 0 0 rgba(0,0,0,0)" },
                                hover: {
                                    boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
                                },
                            }}
                            transition={{
                                type: "spring",
                                stiffness: 300,
                                damping: 24,
                            }}
                        >
                            <h2>{project.name}</h2>
                            <motion.p
                                className="overflow-hidden text-ellipsis transition-all duration-300 group-hover:!line-clamp-none"
                                variants={{
                                    rest: { maxHeight: 48 },
                                    hover: { maxHeight: 500 },
                                }}
                                style={{
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: 2,
                                    transition:
                                        "max-height 0.5s cubic-bezier(0.4,0,0.2,1)",
                                }}
                                transition={{
                                    duration: 0.5,
                                    ease: [0.4, 0, 0.2, 1],
                                }}
                            >
                                {project.description}
                            </motion.p>
                            <div className="flex gap-1.5">
                                <Button
                                    onClick={() => {
                                        if (!project.link) {
                                            window.alert("Link coming soon");
                                        } else {
                                            window.open(project.link, "_blank");
                                        }
                                    }}
                                    variant="Outline"
                                >
                                    <AddCircle
                                        size={18}
                                        iconStyle="LineDuotone"
                                        marginHeight={0}
                                        color="#ffffff"
                                    />
                                    <span className="text-sm">Live</span>
                                </Button>
                                <Button
                                    onClick={() => {
                                        if (!project.link) {
                                            window.alert("Link coming soon");
                                        } else {
                                            window.open(
                                                project.github,
                                                "_blank",
                                            );
                                        }
                                    }}
                                    variant="Outline"
                                >
                                    <Copy
                                        size={18}
                                        iconStyle="LineDuotone"
                                        marginHeight={0}
                                        color="#ffffff"
                                    />
                                    <span className="text-sm">GitHub</span>
                                </Button>
                            </div>
                            <motion.div
                                className="w-full aspect-video bg-background rounded"
                                children={project.image}
                                variants={{
                                    rest: { scale: 1 },
                                    hover: { scale: 1.06 },
                                }}
                                transition={{
                                    type: "spring",
                                    stiffness: 300,
                                    damping: 24,
                                }}
                            />
                            {/* Tech stack, only visible on hover */}
                            <motion.div
                                className="w-full mt-2 flex flex-wrap gap-2"
                                initial={{ opacity: 0, height: 0 }}
                                variants={{
                                    rest: { opacity: 0, height: 0 },
                                    hover: { opacity: 1, height: "auto" },
                                }}
                                transition={{
                                    duration: 0.3,
                                    ease: "easeInOut",
                                }}
                            >
                                {project.tech.map((tech: string, i: number) => (
                                    <span
                                        key={i}
                                        className="bg-muted px-2 py-0.5 rounded text-sm text-foreground/80 border border-border"
                                    >
                                        {tech}
                                    </span>
                                ))}
                            </motion.div>
                        </motion.div>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    );
};
